import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";

//Import Images
import errorImg from "../../assets/images/404-error.png";
import SecondaryButton from "../../components/Common/SecondaryButton";

const Pages404 = () => {
  document.title = " Error 404 | Omaha Food Lovers";

  useEffect(() => {
    document.body.className = "authentication-bg";
    // remove classname when component will unmount
    return function cleanup() {
      document.body.className = "";
    };
  });

  return (
    <React.Fragment>
      <div className="my-5 pt-sm-5">
        <Container>
          <Row>
            <Col md={12}>
              <div className="text-center">
                <div>
                  <Row className="row justify-content-center">
                    <Col sm={4}>
                      <div className="error-img">
                        <img
                          src={errorImg}
                          alt=""
                          className="img-fluid mx-auto d-block"
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
                <h4 className="text-uppercase mt-4">Page Not Found</h4>
                <p className="text-muted">
                  The page you're looking for doesn't exist or has been moved.
                </p>
                <div className="mt-5">
                  <Link to="/">
                    <SecondaryButton label="Back to Home" variant="orange" />
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Pages404;
